import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fb6d334a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fb6d334a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6d334a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6d334a')) {
      api.createRecord('fb6d334a', component.options)
    } else {
      api.reload('fb6d334a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fb6d334a&scoped=true", function () {
      api.rerender('fb6d334a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic-class-item-table/index.vue"
export default component.exports